module.exports = __webpack_public_path__ + "static/media/MyHistory@3x.0bb1d12c.png";